


























import { Vue, Component, Prop } from 'vue-property-decorator'

import { $db } from '@/services/Db'

interface Coupon {
	id: string
	SKU?: string
	expires?: string
	license?: string
}

const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

@Component
export default class BulkCreateCoupons extends Vue {

	@Prop() coupons!: Coupon[]

	base = ''
	count = 1

	SKU = ''
	expires = ''

	uploading = false
	error = ''

	get submitDisabled() {
		return !this.base || this.count < 1 || this.count > 999999
	}

	async create() {
		this.uploading = true
		this.error = ''

		const takenCodes = {}
		const newCodes: Coupon[] = []
		this.coupons.forEach(coupon => {
			takenCodes[coupon.id] = true
		})

		for(let i = 0; i < this.count; i++) {
			let code: string
			do {
				code = this.base + '-' + this.random()
			} while(takenCodes[code] != undefined)
			takenCodes[code] = true
			newCodes.push({
				id: code,
				SKU: this.SKU || undefined,
				expires: this.expires || undefined
			})
		}

		try {
			await Promise.all(newCodes.map(coupon => $db.query(`
				mutation CreateCoupon($coupon: CouponInput!) {
					createCoupon(input: $coupon) {
						id expires SKU license
					}
				}
			`, { coupon })))
		} catch(err) {
			this.error = err.message
		}

		this.uploading = false
	}

	random() {
		let str = ''
		for(let i = 0; i < 6; i++) {
			str += numbers[Math.floor(Math.random() * numbers.length)]
		}
		return str
	}

}
